import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b68aace0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=b68aace0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68aace0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/data/jenkins/workspace/etower/etower-qa-tracking-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b68aace0')) {
      api.createRecord('b68aace0', component.options)
    } else {
      api.reload('b68aace0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b68aace0&scoped=true", function () {
      api.rerender('b68aace0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CopyDialog/index.vue"
export default component.exports